import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HomeIcon from '@material-ui/icons/Home'

import './FilAriane.css';


class FilAriane extends Component {

    render() {
        var currUrl = "";
        var separator = ""; 
        var retour;
        return (
            <div id="filAriane">
                <div className="filArianeChild" style={{"verticalAlign": "middle"}}>
                    <HomeIcon color="action" style={{ fontSize: 20 }} />
                </div>
                {
                    this.props.pages.map(page => {
                        retour = "";
                        if(page !== "") {
                            currUrl += "/" + page; 
                            retour = (<div key={currUrl} className="filArianeChild">{separator}<a href={currUrl}>{page}</a></div>);
                            separator = " / ";
                        }
                        return retour;
                    })
                }
            </div>
        );
    }
}

FilAriane.propTypes = {
    pages: PropTypes.array.isRequired,
};

export default FilAriane;



// WEBPACK FOOTER //
// ./src/components/custom/filAriane/FilAriane.js